// Which kind of pick the picker is on, for the label strip under the
// top bar's progress line. The wave header's pick_type alone can't
// tell a Putwall wave or a two-bay Pick & Sort wave from a plain one —
// those live on sort_station / wave_size — so this is the one place
// that folds the three columns into a display kind + i18n key. Absent
// columns (an older BE payload) read as the plain variant.
import type { ActiveWaveHeader } from "../../hooks/useActiveWave";

export type PickTypeKind = "light" | "pick_and_sort" | "put_wall" | "large";

type WaveShape = Pick<ActiveWaveHeader, "pick_type"> &
    Partial<Pick<ActiveWaveHeader, "sort_station" | "wave_size">>;

export const pickTypeKindFor = (wave: WaveShape): PickTypeKind => {
    if (wave.pick_type === "pick_and_sort") {
        return wave.sort_station === "put_wall" ? "put_wall" : "pick_and_sort";
    }
    return wave.pick_type === "large" ? "large" : "light";
};

/** i18n key for the strip's text. A two-bay Pick & Sort wave says so,
 *  because the picker chose that size on the selector and the sorters
 *  need the totes spread over both bays. */
export const pickTypeLabelKeyFor = (wave: WaveShape): string => {
    const kind = pickTypeKindFor(wave);
    if (kind === "pick_and_sort" && wave.wave_size === "large") {
        return "picking_pick_type_pick_and_sort_large";
    }
    return `picking_pick_type_${kind}`;
};
